module.exports = {"setting":{"addBtn":"","breadcrumb":"Configuration","header":{"edit":"Configuration"},"itemAddedMessage":"","itemDeletedMessage":"","itemModalDeleteConfirmMessage":"","itemModifiedMessage":"Les configurations ont été modifiées avec succès.","listDeletedMessage":"","listModalDeleteConfirmMessage":"","name":"Configuration","searchBar":""}}


//////////////////
// WEBPACK FOOTER
// ./helpers/setting/lang/admin-fr.json
// module id = GuAe
// module chunks = 18